export enum PropertyType {
  PRIMARY_RESIDENTIAL = "primary_residential",
  PRIMARY_COMMERCIAL = "primary_commercial",
  PRIMARY_HOTELS = "primary_hotels",
  BUY_RESIDENTIAL = "buy_residential",
  BUY_COMMERCIAL = "buy_commercial",
  BUY_LAND = "buy_land",
  RENT_RESIDENTIAL = "rent_residential",
  RENT_COMMERCIAL = "rent_commercial",
  RENT_LAND = "rent_land",
}
